import { Form, Input, Space } from 'antd'

import FeedUrlSourceAuthenticationBaseForm from './FeedAuthenticationBaseForm'

interface FeedUrlSourceAuthenticationBasicProps {
  isSubmitted?: boolean
  onSubmit: (credentials: { username: string; password: string }) => void
  initialValues?: { username: string; password: string }
}

function FeedUrlSourceAuthenticationBasic({
  isSubmitted,
  onSubmit,
  initialValues,
}: FeedUrlSourceAuthenticationBasicProps): JSX.Element {
  const [basicAuthForm] = Form.useForm()

  return (
    <FeedUrlSourceAuthenticationBaseForm
      form={basicAuthForm}
      isSubmitted={isSubmitted}
      shouldValidate={false}
      onSubmit={onSubmit}
      {...(initialValues
        ? {
            initialValues: {
              username: initialValues.username,
              password: initialValues.password,
            },
          }
        : {})}
    >
      <Space.Compact block className="mb-4">
        <Form.Item
          label="Username"
          className="[&>div>.ant-form-item-label]:!pb-0 [&>div>.ant-form-item-label>label]:text-gray-700 [&>div>.ant-form-item-label>label]:font-medium [&>div>.ant-form-item-label]:mb-0 [&>div>.ant-form-item-label]:text-sm mb-0 flex-1 [&>div>div>.ant-form-item-additional]:absolute [&>div>div>.ant-form-item-additional]:text-error-700"
          htmlFor="username"
          name="username"
        >
          <Input
            allowClear
            placeholder="Enter username"
            name={Math.random().toString(36)}
            className="flex h-[40px] justify-between border rounded-lg w-full !p-0 !pr-2 [&>input]:!p-2.5 [&>input]:!leading-none [&>input]:text-[100%] text-gray-900 bg-white-100 !border-gray-300 [&.ant-input-status-error]:!border-error-300"
            autoComplete="off"
          />
        </Form.Item>
      </Space.Compact>
      <Space.Compact block className="mb-12">
        <Form.Item
          label="Password"
          className="[&>div>.ant-form-item-label]:!pb-0 [&>div>.ant-form-item-label>label]:text-gray-700 [&>div>.ant-form-item-label>label]:font-medium [&>div>.ant-form-item-label]:mb-0 [&>div>.ant-form-item-label]:text-sm mb-0 flex-1 [&>div>div>.ant-form-item-additional]:absolute [&>div>div>.ant-form-item-additional]:text-error-700"
          htmlFor="password"
          name="password"
        >
          <Input.Password
            placeholder="Enter password"
            name={Math.random().toString(36)}
            visibilityToggle
            className="flex h-[40px] justify-between border rounded-lg w-full !p-0 !pr-2 [&>input]:!p-2.5 [&>input]:!leading-none [&>input]:text-[100%] text-gray-900 bg-white-100 !border-gray-300 [&.ant-input-status-error]:!border-error-300"
            autoComplete="new-password"
          />
        </Form.Item>
      </Space.Compact>
    </FeedUrlSourceAuthenticationBaseForm>
  )
}

export default FeedUrlSourceAuthenticationBasic
